import React from 'react';
import Icon from '../../../components/AppIcon';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const LocationComplianceChart = ({ data }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground mb-1">Location-Based Compliance Rates</h3>
          <p className="text-sm text-muted-foreground">Performance comparison across facilities</p>
        </div>
        <Icon name="BarChart3" size={20} color="var(--color-muted-foreground)" />
      </div>

      <div className="h-64 mb-6">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="location" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="completed" fill="#10b981" name="Completed" />
            <Bar dataKey="overdue" fill="#ef4444" name="Overdue" />
            <Bar dataKey="atRisk" fill="#f59e0b" name="At Risk" />
          </BarChart>
        </ResponsiveContainer>
      </div>

      <div className="space-y-3">
        {data?.map((location, index) => (
          <div key={index} className="p-4 bg-muted/50 rounded-lg">
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center gap-2">
                <Icon name="MapPin" size={16} color="var(--color-muted-foreground)" />
                <span className="font-medium text-foreground">{location?.location}</span>
              </div>
              <span className="text-sm font-semibold text-foreground">{location?.rate}%</span>
            </div>
            <div className="w-full bg-muted rounded-full h-2">
              <div
                className="bg-success h-2 rounded-full transition-all"
                style={{ width: `${location?.rate}%` }}
              />
            </div>
            <div className="flex items-center justify-between mt-2 text-xs text-muted-foreground">
              <span>{location?.completed} of {location?.total} compliant</span>
              <div className="flex items-center gap-3">
                {location?.overdue > 0 && (
                  <span className="text-destructive">{location?.overdue} overdue</span>
                )}
                {location?.atRisk > 0 && (
                  <span className="text-orange-500">{location?.atRisk} at risk</span>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LocationComplianceChart;